import { Cell } from '@pelckmans/elementis/components/table/cell';
import CalendarIcon from '@pelckmans/elementis/icons/calendar';
import { formatDate } from '../../../../../../utils/formatDate';

export default function DateCell({
  completedBySystem,
  isZeroScore,
  achievedAt,
}: {
  completedBySystem: boolean;
  isZeroScore: boolean;
  achievedAt?: string;
}) {
  return (
    <Cell>
      {!(completedBySystem && isZeroScore) && achievedAt ? (
        <Cell.Text startAdornment={<CalendarIcon data-testid="calendar-icon" />} title={formatDate(achievedAt)} />
      ) : null}
    </Cell>
  );
}
